var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreateRegInventory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7201_98999)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.1996 37.9409H48.2568V30.7795H30.8165V26.075H38.7754C39.7662 26.075 40.5718 25.2775 40.5718 24.2867V4.79224C40.5718 3.80141 39.7662 3.00391 38.7754 3.00391H19.2165C18.2257 3.00391 17.4201 3.80141 17.4201 4.79224V24.2786C17.4201 25.2695 18.2257 26.067 19.2165 26.067H27.2237V30.7714H9.73514V37.9328H1.79236C0.801527 37.9328 -0.00402832 38.7303 -0.00402832 39.7211V59.2075C-0.00402832 60.1983 0.801527 60.9959 1.79236 60.9959H21.3593C22.3501 60.9959 23.1557 60.1983 23.1557 59.2075V39.7211C23.1557 38.7303 22.3501 37.9328 21.3593 37.9328H13.336V34.3481H44.664V37.9328H36.6407C35.6499 37.9328 34.8443 38.7303 34.8443 39.7211V59.2075C34.8443 60.1983 35.6499 60.9959 36.6407 60.9959H56.2076C57.1985 60.9959 58.004 60.1983 58.004 59.2075V39.7211C58.004 38.7303 57.1985 37.9328 56.2076 37.9328L56.1996 37.9409ZM21.0129 6.58057H36.9871V22.4903H21.0129V6.58057ZM19.5629 57.4192H3.58875V41.5095H19.5629V57.4192ZM54.4032 57.4192H38.429V41.5095H54.4032V57.4192Z",
    fill: "#474747"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7201_98999"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    fill: "white",
    transform: "translate(0 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateRegInventory);
export default __webpack_public_path__ + "static/media/create-reg-inventory.c49aaa47c88ea059b1f7a7daa743313a.svg";
export { ForwardRef as ReactComponent };